import { Card, CardFooter } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Share2, Download } from "lucide-react"
import UFOLayout from "../templates/UFOLayout"
import { useImageDownload } from "@/hooks/useImageDownload"
import { useShare } from "@/hooks/useShare"
import { GeneratedCardData, CardData, UFOCardMetadata } from "@/types/card"

interface UFOPreviewProps {
  data: GeneratedCardData;
  onBack: () => void;
}

interface UFOCardData {
  title?: string;
  description?: string;
  imageUrl?: string;
  metadata: UFOCardMetadata;
}

export function UFOPreview({ data, onBack }: UFOPreviewProps) {
  const { handleDownload, cardRef } = useImageDownload();
  const { handleShare } = useShare();

  const ufoData: UFOCardData = {
    ...data,
    metadata: {
      documentType: (data.metadata as UFOCardMetadata)?.documentType || 'Unknown',
      type: (data.metadata as UFOCardMetadata)?.type || 'Unknown',
      era: (data.metadata as UFOCardMetadata)?.era || 'Unknown',
      classification: (data.metadata as UFOCardMetadata)?.classification || 'Unknown',
      sourceQuality: (data.metadata as UFOCardMetadata)?.sourceQuality || 'Unknown',
      language: data.metadata?.language || 'en',
      playerName: data.metadata?.playerName || 'Anonymous',
      siteType: (data.metadata as UFOCardMetadata)?.siteType,
      entityType: (data.metadata as UFOCardMetadata)?.entityType,
      mediaType: (data.metadata as UFOCardMetadata)?.mediaType,
      artifactType: (data.metadata as UFOCardMetadata)?.artifactType
    }
  };

  // Create a CardData object for share/download
  const shareData: CardData = {
    title: data.title || 'Untitled',
    description: data.description || '',
    imageUrl: data.imageUrl,
    category: data.theme,
    fields: data.fields,
    language: data.language,
    playerName: data.playerName,
    userId: data.userId || undefined,
  };

  return (
    <Card className="w-[400px]" ref={cardRef}>
      <div className="flex justify-center w-full mt-6">
        <UFOLayout cardData={ufoData} />
        </div>
        <CardFooter className="flex gap-2 mt-4">
          <Button variant="outline" onClick={onBack} className="flex-1">
            Back to Editor
          </Button>
          <Button variant="outline" size="icon" onClick={() => handleShare(shareData)} className="w-10">
            <Share2 className="h-4 w-4" />
          </Button>
          <Button variant="outline" size="icon" onClick={() => handleDownload(shareData.title)} className="w-10">
            <Download className="h-4 w-4" />
          </Button>
        </CardFooter>
      </Card>
  );
}

export default UFOPreview; 